import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import customStyles from '../Helpers/ReactSelectStyle';
import { FieldInputProps } from '../Constants/ReduxFormPropTypes';

const SelectList = ({ options, input, disabled, placeholder, searchable }) => {
  // Options are defined in terms of their { value: , label: } object
  // this pulls the option whose value property equals the value argument
  const getOptionFromValue = (value) =>
    options.reduce(
      (carry, current) => (current.value === value ? current : carry),
      null,
    );
  // Manage the value from props
  // if the input data includes a value, use it
  // else if there is a placeholder, don't impose a value
  // else the value is the first option
  const value = () =>
    getOptionFromValue(input.value) ||
    (!placeholder && options[0]) ||
    undefined;

  return (
    <Select
      options={options}
      id={input.name}
      disabled={disabled}
      className="w-100"
      autoSize
      value={value()}
      onChange={(v) => input.onChange(v.value)}
      onBlur={() => input.onBlur()}
      styles={customStyles}
      isClearable={false}
      isSearchable={searchable}
      placeholder={placeholder}
    />
  );
};

SelectList.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ).isRequired,
  input: FieldInputProps.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
};

SelectList.defaultProps = {
  disabled: false,
  placeholder: undefined,
  searchable: false,
};

export default SelectList;
